import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['modalBody']

  onEventClick(e) {
    const { event } = e.detail
    const {
      simplero_live: simpleroLive,
      show_url: showUrl,
      card_url: cardUrl,
      occurrence_id: occurrenceId,
    } = event.extendedProps || {}

    // Simplero Live events have no inline details modal on the member-facing site, so open
    // their event page in a new tab instead — mirroring the events list view. Inside the mobile
    // app's WebView, a new-window request from this non-anchor calendar chip can't be
    // hit-tested by the native handler and silently does nothing (ENG-34417), so navigate the
    // WebView itself there instead.
    if (simpleroLive && showUrl) {
      if (document.documentElement.classList.contains('turbo-native')) {
        window.location.href = showUrl
      } else {
        window.open(showUrl, '_blank', 'noopener')
      }
      return
    }

    // Builder listings embed the same occurrence modal as the list view so calendar
    // clicks work on landing pages that have no /events/:id/card endpoint.
    if (occurrenceId) {
      const modal = document.getElementById(
        `modal_event_occurrence_${occurrenceId}`
      )
      if (modal) {
        modal.dispatchEvent(new CustomEvent('modal:show'))
        return
      }
    }

    if (!cardUrl) return

    const modal = document.getElementById('calendar-event-modal')
    if (!modal) return

    // Show modal with loading state
    this.modalBodyTarget.innerHTML =
      '<div class="flex items-center justify-center py-8"><div class="animate-spin h-6 w-6 border-2 border-current border-t-transparent rounded-full"></div></div>'
    modal.dispatchEvent(new CustomEvent('modal:show'))

    // Fetch the event card content
    fetch(cardUrl, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok)
          throw new Error(`Card fetch failed: ${response.status}`)
        return response.text()
      })
      .then((html) => {
        this.modalBodyTarget.innerHTML = html
      })
      .catch(() => {
        modal.dispatchEvent(new CustomEvent('modal:hide'))
      })
  }
}
